import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { httpInterceptorProviders } from '@shared/classes/interceptors/http-interceptors';
import { ModalModule } from '@shared/components/modal/modal.module';
import { MostUsedModule } from '@shared/components/most-used/most-used.module';
import { SearchModule } from '@shared/components/search/search.module';
import { TinyKitModule } from '@shared/components/tiny-kit/tiny-kit.module';
import { UnsavedChangesModule } from '@shared/components/unsaved-changes/unsaved-changes.module';
import { UserEditModule } from '@shared/components/users/user-edit/user-edit.module';
import { UnsavedChangingsGuard } from '@shared/guards/unsaved-changings.guard';
import { CurrentUserService } from '@shared/services/current-user.service';
import { InitLangService } from '@shared/services/init-lang.service';
import { CustomizedPaginatorIntl } from '@shared/utils/paginator.intl';
import { NgxMaskModule } from 'ngx-mask';
import { NgxOutsideClickModule } from 'ngx-outside-click';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CpLayoutComponent } from './cp-layout/cp-layout.component';
import { PICK_FORMATS, PickDateAdapter } from '@shared/utils/datepicker-format';
import { TemporalPageComponent } from '@shared/components/temporal-page/temporal-page.component';
import { GlobalErrorHandler } from '@shared/classes/errors/global-error-handler';


export function initializeApp(
  currentUserService: CurrentUserService,
  initLangService: InitLangService
  ) {
  return (): Promise<any> => {
    // console.log(initLangService);
    initLangService.init();
    return currentUserService.init();
  };
}

@NgModule({
  declarations: [AppComponent, CpLayoutComponent, TemporalPageComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatNativeDateModule,
    UnsavedChangesModule,
    ModalModule,
    SearchModule,
    UserEditModule,
    MostUsedModule,
    NgxMaskModule.forRoot(),
    TinyKitModule,
    NgxOutsideClickModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler, },
    ...httpInterceptorProviders,
    { provide: MatPaginatorIntl, useClass: CustomizedPaginatorIntl },
    UnsavedChangingsGuard,
    CurrentUserService,
    InitLangService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp, deps: [CurrentUserService, InitLangService],
      multi: true
    },
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
